import { breakpoints } from '../variables';

import {
  colorRules,
  shadowRules,
  radiiRules,
  backgroundColorRules,
  marginRules,
  marginCrossRules,
  paddingRules,
  paddingCrossRules,
  textSizeRules,
  fontWeightRules,
  textVariantRules,
  textAlignmentRules,
  borderRules,
  displayRules,
  flexWrapRules,
  flexDirectionRules,
  flexItemRules,
  JustifyContentRules,
  growRules,
  shrinkRules,
  alignSelfRules,
  overflowRules,
  positionRules,
  sidePositionRules,
  widthRules,
  minWidthRules,
  heightRules,
  ellipsisRules,
  accessibilityRules,
} from './rules';

const separator = '\\:';

const allRules = [
  ...colorRules,
  ...shadowRules,
  ...radiiRules,
  ...backgroundColorRules,
  ...marginRules,
  ...marginCrossRules,
  ...paddingRules,
  ...paddingCrossRules,
  ...textSizeRules,
  ...fontWeightRules,
  ...textVariantRules,
  ...textAlignmentRules,
  ...borderRules,
  ...displayRules,
  ...flexWrapRules,
  ...flexDirectionRules,
  ...flexItemRules,
  ...JustifyContentRules,
  ...growRules,
  ...shrinkRules,
  ...alignSelfRules,
  ...overflowRules,
  ...positionRules,
  ...sidePositionRules,
  ...widthRules,
  ...minWidthRules,
  ...heightRules,
  ...ellipsisRules,
  ...accessibilityRules,
];

export const objectToRuleset = (rules: any[], prefix?: string) => {
  const result = [];
  const prefixString = prefix ? `${prefix}-` : '';

  rules.map(rule => {
    const declarations = [];

    rule.declarations.map(declaration => {
      declarations.push(`${declaration.property}:${declaration.value}`);
    });

    const string = `.${prefixString}${rule.selector}${
      rule.modifier ? separator : ''
    }${rule.modifier ? rule.modifier : ''}{${declarations.join(';')}}`;

    result.push(string);
  });

  return result.join('');
};

export const shortBreakpoints = {
  xs: breakpoints.xsmall,
  sm: breakpoints.small,
  md: breakpoints.medium,
  lg: breakpoints.large,
};

export const cssUtilities = () => {
  const getRulesetsInMedia = () => {
    const result = [];

    result.push(`${objectToRuleset(allRules)}`);

    Object.entries(shortBreakpoints).map(([key, value]) => {
      result.push(
        `@media(min-width:${value}){${objectToRuleset(allRules, key)}}`
      );
    });

    return result.join('');
  };

  return getRulesetsInMedia();
};
